import { createConsumer, createSubscriber, getGlobalEventsLogs, IConsumer, IEvent } from '@cian/events-log';

import { TThunkAction } from '../../types/redux';
import { getUser, setUserData } from '../user';

interface IViewData {
  headingType: string | undefined;
}

export interface IRequestAuthenticationParameters {
  viewData?: IViewData;
  onSuccess?(): void;
  onCloseNoAuth?(): void;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return dispatch => {
    if (typeof window !== 'undefined') {
      const globalLog = getGlobalEventsLogs();
      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          dispatch(setUserData({ isAuthenticated: true }));

          await dispatch(getUser());

          if (window.__reloadHeader__) {
            window.__reloadHeader__();
          }

          if (parameters && parameters.onSuccess) {
            parameters.onSuccess();
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          if (parameters && parameters.onCloseNoAuth) {
            parameters.onCloseNoAuth();
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);

      globalLog.produce(TOPIC_USER, {
        type: 'authenticate',
        value: {
          autoRefresh: false,
          viewData: parameters?.viewData || {},
        },
      });
    }
  };
}
